import React from 'react';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Legal & Compliance Information Hub
          </h1>
          
          <p className="text-gray-700 leading-relaxed mb-8">
            This website serves as the centralized legal and compliance information hub for 
            websites, landing pages, and digital properties operated or controlled by Nexa Nova Media LLC.
          </p>
          
          <p className="text-gray-700 leading-relaxed mb-8">
            For information about how we collect, use, and protect data, or to review our terms, 
            disclaimers, and policies, please visit the pages below.
          </p>
        </div>

        <div className="space-y-4 mb-8">
          <a 
            href="https://nnmedia.co/privacy-policy" 
            className="block w-full p-4 text-left bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-colors duration-200"
          >
            <span className="text-blue-700 font-semibold">Privacy Policy</span>
          </a>
          
          <a 
            href="https://nnmedia.co/terms-and-conditions" 
            className="block w-full p-4 text-left bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-colors duration-200"
          >
            <span className="text-blue-700 font-semibold">Terms & Conditions</span>
          </a>
          
          <a 
            href="https://nnmedia.co/disclaimer" 
            className="block w-full p-4 text-left bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-colors duration-200"
          >
            <span className="text-blue-700 font-semibold">Disclaimer</span>
          </a>
          
          <a 
            href="https://nnmedia.co/contact" 
            className="block w-full p-4 text-left bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-colors duration-200"
          >
            <span className="text-blue-700 font-semibold">Contact</span>
          </a>
        </div>

        <div className="text-center pt-6 border-t border-gray-200">
          <p className="text-gray-600 text-sm">
            © Nexa Nova Media LLC
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;